<template>
  <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" center :close-on-click-modal="false"
    :close-on-press-escape="true">
    <div class="dialog-content">
      <el-image :src="imageUrl" fit="contain" :style="imageStyle">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
          <p>图片加载失败</p>
        </div>
      </el-image>
      <span class="dialog-footer">
        <i class="el-icon-circle-close close-icon" @click="closeDialog"></i>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImagePreviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    width: {
      type: [String, Number],
      // default: '600px'
    },
    height: {
      type: [String, Number],
      // default: '500px'
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    dialogWidth() {
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },
    imageStyle() {
      const height = typeof this.height === 'number' ? `${this.height}px` : this.height;
      return {
        height: height,
        borderRadius: '10px'
      };
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  text-align: center;
  position: relative;
  border-radius: 10px;

  .image-slot {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    // background: #f5f7fa;
    color: #909399;

    i {
      font-size: 40px;
      margin-bottom: 10px;
    }
  }
}

:deep(.el-dialog) {
  background: transparent;
  box-shadow: none !important;
}

:deep(.el-dialog .el-dialog__header) {
  display: none;
}

:deep(.el-dialog__body) {
  padding: 0;
  background-color: transparent;
}

.dialog-footer {
  position: absolute;
  bottom: -80px;
  left: 50%;
  transform: translateX(-50%);

  .close-icon {
    font-size: 40px;
    background-color: rgba(0, 0, 0, .2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;

    &:hover {
      opacity: .8;
    }
  }
}
</style>